import { ToolId } from '@domain/filters'
import { createCtx } from '@shared/hooks'

export const [useEffectInfo, EffectProvider] = createCtx<{ toolId: ToolId }>()
